import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import NotificacionesLayer from "../../components/comprobantes/NotificacionesLayer"

const Notificaciones = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Notificaciones" />

        {/* RoleAccessLayer */}
        <NotificacionesLayer/>

      </MasterLayout>

    </>
  );
};

export default Notificaciones; 
